import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ClickDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="relative inline-block">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow-lg"
      >
        Click Me
      </button>
      {isOpen && (
        <div className="absolute left-0 mt-2 w-40 bg-white border border-gray-300 rounded-lg shadow-lg">
          <button
            className="w-full px-4 py-2 text-left hover:bg-gray-200"
            onClick={() => { setIsOpen(false); navigate("/route1"); }}
          >
            Go to Route 1
          </button>
          <button
            className="w-full px-4 py-2 text-left hover:bg-gray-200"
            onClick={() => { setIsOpen(false); navigate("/route2"); }}
          >
            Go to Route 2
          </button>
        </div>
      )}
    </div>
  );
}
